// extracted by mini-css-extract-plugin
module.exports = {"tag":"tag_tag__T09qf","yellow":"tag_yellow__UccRY","turquoise":"tag_turquoise__nwS2o","blue":"tag_blue__EqUNQ","magenta":"tag_magenta__ponXI","blur":"tag_blur__T_e5f"};